import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { RoundedIcon, RoundIcon } from '../../icons';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';
import { IMainMenuItem } from './interfaces/main-menu-item.interface';
import { IconModule } from '@insolution/core-data-access';

@Component({
  selector: 'lib-main-menu',
  imports: [TranslatePipe, IconModule, RoundIcon, RoundedIcon, RouterLink, NgClass],
  templateUrl: './main-menu.html',
  styleUrl: './main-menu.scss',
})
export class MainMenu {
  menuItems = input.required<IMainMenuItem[]>();
}
